import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import history from '../../../history'
// import usePrev from '../../../hooks/usePrev'
import { OVERLAY_HELPERS } from '../../../constants/navigation'
import { saveClientData, resetClientStatus } from '../../../actions/client'
import { selectClientMobile } from '../../../store/selectors/client'
import { Callout, Button, Text, Format } from '../..'

import styles from './TextUpdatesCallout.module.scss'

export const TextUpdatesCallout = () => {
  const dispatch = useDispatch()
  const clientMobile = useSelector(selectClientMobile)
  // const hasOptedIn = useSelector(selectClientHasSubscribedToSms)
  // const wasOptedIn = usePrev(hasOptedIn)

  const [show, setShow] = useState(false)

  const resendText = () =>
    dispatch(saveClientData({ 'resend-welcome-text': true }))
  const navToTextUpdate = () => {
    dispatch(resetClientStatus())
    history.push(OVERLAY_HELPERS.textUpdates.buildPath())
    setShow(false)
  }
  const handleClose = () => setShow(false)

  // DISABLED WHILE UNDER CONSTRUCTION
  // useEffect(() => {
  //   if (wasOptedIn === false && hasOptedIn) {
  //     setShow(true)
  //   }
  // }, [wasOptedIn, hasOptedIn])

  return (
    <Callout show={show} onClose={handleClose}>
      <Text variant='neutralCool' variantCount='900'>
        <FormattedMessage
          id='TextUpdatesCallout.text'
          defaultMessage='We sent a confirmation text to'
        />
      </Text>
      <Text variant='neutralCool' variantCount='900'>
        <Format.Phone value={clientMobile} />
      </Text>
      <div className={styles.buttonWrap}>
        <Button className={styles.button} onClick={resendText}>
          <FormattedMessage
            id='TextUpdatesCallout.button.resend'
            defaultMessage='I didn’t get text message'
          />
        </Button>
        <Button className={styles.button} onClick={navToTextUpdate}>
          <FormattedMessage
            id='TextUpdatesCallout.button.edit'
            defaultMessage='Edit number'
          />
        </Button>
      </div>
    </Callout>
  )
}

export default TextUpdatesCallout
